export const TableColumns = [
    { text: "Mã chi phí", icon: <></> },
    { text: "Tên chi phí", icon: <></> },
    { text: "Danh mục", icon: <></> },
    { text: "Giá", icon: <></> },
];

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Tên chi phí, Mã chi phí",
};